"use client";

import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function Professionaltestimonials() {
  const featuredTestimonials = [{
    quote: "Tiny to Teen Supervised Parenting & Education Services provided the neutral, structured environment we needed. Their professionalism helped us navigate a very difficult transition with grace.",
    author: "SARAH J.",
    position: "PARENT",
    since: "CLIENT SINCE 2023"
  }, {
    quote: "As an attorney, I rely on neutral, trauma-informed support for my clients. Tiny to Teen Supervised Parenting & Education Services consistently delivers reliable, child-centered documentation.",
    author: "ROBERT M.",
    position: "FAMILY LAW ATTORNEY",
    since: "PARTNER SINCE 2022"
  }, {
    quote: "The team's commitment to safety and firm boundaries allowed our family to focus on reunification in a calm, supported space.",
    author: "DAVID L.",
    position: "PARENT",
    since: "CLIENT SINCE 2023"
  }];
  const smallerTestimonials = [{
    quote: "Professional, neutral, and deeply compassionate. They truly put the child's needs at the center of every interaction.",
    author: "ELENA V.",
    position: "CASE MANAGER"
  }, {
    quote: "The observation reporting is thorough and objective. It has been an invaluable resource for our court proceedings.",
    author: "JONATHAN P.",
    position: "COURT LIAISON"
  }, {
    quote: "A steady, grounded presence during a high-conflict time. Their structure made all the difference for our family.",
    author: "ISABELLA C.",
    position: "PARENT"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const handlePrev = () => {
    setActiveIndex(prev => prev === 0 ? featuredTestimonials.length - 1 : prev - 1);
  };
  const handleNext = () => {
    setActiveIndex(prev => prev === featuredTestimonials.length - 1 ? 0 : prev + 1);
  };
  const active = featuredTestimonials[activeIndex];
  return <section data-section-id="5022" id="professionaltestimonials" className="bg-background text-foreground relative overflow-hidden py-[180px] px-6 md:px-12 lg:px-20">
      {}
      <div className="relative flex flex-col md:flex-row md:justify-between md:items-start gap-8 mb-24">
        <div className="font-default text-xs tracking-widest uppercase" style={{
        color: "var(--secondary)"
      }}>
          05 / TESTIMONIALS
        </div>
        <h2 className="font-default font-bold uppercase text-4xl md:text-6xl lg:text-[72px] leading-[0.95] tracking-tight text-right">
          VOICES OF
          <br />
          TRUST
          <span style={{
          color: "var(--primary)"
        }}>.</span>
        </h2>
      </div>

      {}
      <div className="relative max-w-[900px] mx-auto mb-32">
        {}
        <div className="absolute -top-24 -left-8 md:-top-32 md:-left-16 font-default font-bold leading-none pointer-events-none select-none" style={{
        color: "var(--primary)",
        fontSize: "200px",
        lineHeight: "1",
        opacity: 0.3
      }} aria-hidden="true">
          &ldquo;
        </div>

        <div className="relative pt-12 md:pt-20 md:pl-16">
          <blockquote className="font-default italic text-2xl md:text-3xl lg:text-[36px] leading-[1.3] text-foreground">
            {active.quote}
          </blockquote>

          {}
          <div className="mt-12 h-px w-20" style={{
          backgroundColor: "var(--primary)"
        }} />

          {}
          <div className="mt-6 font-default text-xs tracking-widest text-foreground/70 space-y-1">
            <div className="font-bold">{active.author}</div>
            <div>{active.position}</div>
            <div>{active.since}</div>
          </div>
        </div>

        {}
        <div className="absolute right-0 top-1/2 -translate-y-1/2 hidden md:flex flex-col gap-3">
          <Button variant="ghost" size="icon" onClick={handlePrev} aria-label="Previous testimonial" className="h-10 w-10 border border-primary hover:bg-primary hover:text-white">
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="icon" onClick={handleNext} aria-label="Next testimonial" className="h-10 w-10 border border-primary hover:bg-primary hover:text-white">
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>

        {}
        <div className="flex md:hidden gap-3 mt-10 justify-end">
          <Button variant="ghost" size="icon" onClick={handlePrev} aria-label="Previous testimonial" className="h-10 w-10 border border-primary">
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="icon" onClick={handleNext} aria-label="Next testimonial" className="h-10 w-10 border border-primary">
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {}
      <div className="relative">
        <div className="flex gap-6 overflow-x-auto pb-6 snap-x snap-mandatory scrollbar-thin -mx-6 px-6 md:-mx-12 md:px-12 lg:-mx-20 lg:px-20">
          {smallerTestimonials.map((item, i) => <div key={i} data-index={i} className="snap-start flex-shrink-0 w-[320px] md:w-[380px] h-[280px] p-8 flex flex-col justify-between border border-primary/20 bg-card shadow-md">
              <div className="flex items-start justify-between">
                <div className="h-2 w-2" style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true" />
                <span className="font-default text-[10px] tracking-widest text-foreground/60">
                  0{i + 1}
                </span>
              </div>

              <blockquote className="font-default italic text-lg md:text-xl leading-snug text-foreground">
                {item.quote}
              </blockquote>

              <div className="font-default text-[11px] tracking-widest space-y-1">
                <div className="font-bold">{item.author}</div>
                <div className="text-foreground/70">{item.position}</div>
              </div>
            </div>)}
        </div>

        {}
        <div className="flex justify-center gap-2 mt-12">
          {featuredTestimonials.map((_, i) => <Button key={i} data-index={i} onClick={() => setActiveIndex(i)} aria-label={`Go to testimonial ${i + 1}`} variant="ghost" className="h-2 transition-all duration-300 px-0 py-0 rounded-lg" style={{
          width: i === activeIndex ? "32px" : "8px",
          backgroundColor: i === activeIndex ? "var(--primary)" : "var(--secondary)",
          opacity: i === activeIndex ? 1 : 0.4
        }} />)}
        </div>
      </div>
    </section>;
}